import { render, staticRenderFns } from "./DmqMyRegions.vue?vue&type=template&id=7718e12e&"
import script from "./DmqMyRegions.vue?vue&type=script&lang=ts&"
export * from "./DmqMyRegions.vue?vue&type=script&lang=ts&"
import style0 from "./DmqMyRegions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports